import { mapState } from 'vuex'
import { 
  simpleNullFields, 
  emptyArrayFields, 
  falseFields, 
  listSuffixFields,
  advancedComputedFields 
} from '../data/dataOptions.js';

export default {  
  data() {
    const initialData = {
      approximateAge: null,
      pproximateHeight: "",
      textAreaContent: "",
      typeOfWeapon: { id: '', nombre: '' },
      stageOfLife: { id: "2", nombre: "Juvenil" },
      fields: [
        "orejas", "parpados", "menton", "frente", "nariz", "bigote", "edad", "labios", "barba", "cabello", "cejas", "ojos", "cutis", 
        "boca", "description"
      ],
      headPhrase: '',
      sBodyPhrase: '',
      iBodyPhrase: '',
      feetPhrase: '',
      hairPhrase: '',
      texturePhrase: '',
      agePhrase: '',
      mobilityPhrase: '',
      weaponPhrase: '',
      tatooHeadPhrase: { noArticle: '', withArticle: '' },
      tatooBodyPhrase: { noArticle: '', withArticle: '' },
      tatooArmPhrase: { noArticle: '', withArticle: '' },
      tatooLegPhrase: { noArticle: '', withArticle: '' },
      personalAccessoryPhrase: { noArticle: '', withArticle: '' }
    };
    simpleNullFields.forEach(key => { initialData[key] = null; });
    emptyArrayFields.forEach(key => { initialData[key] = []; });
    falseFields.forEach(key => { initialData[key] = false; });
    return initialData;
  },  
  computed: {
    ...mapState(
      Object.fromEntries(
        listSuffixFields
        .filter(key => !emptyArrayFields.includes(`${key}List`))
        .map(key => [`${key}List`, state => state.siis[`${key}List`]])
      )
    ),
    ...generateAdvancedComputed(advancedComputedFields),
    dataVolume: {
      get () { return this.volume },
      set (value) {
        if(value.male === undefined){
          this.volume = null
        } else{
          this.volume = value
        }
        this.createPhrase("texture") 
        this.updateAnswer() 
      }
    },
    dataApproximateHeight: {
      get () { return this.approximateHeight },
      set (value) {
        this.approximateHeight = value
        this.createPhrase("texture") 
        this.updateAnswer() 
      }
    },
    dataApproximateAge: {
      get () { return this.approximateAge },
      set (value) {
        this.approximateAge = value;
        this.createPhrase("age") 
        this.updateAnswer() 
      }
    },
    dataZone: {
      get () { return this.zone },
      set (value) {
        const optionWithGenderData = {
          nameString: "zone",
          nameMultiSelect: "zoneMultiSelect",
          genders: ["nombre", "male"]
        };
        this.selectOptionsMultiSelect(value, optionWithGenderData);
        this.createPhrase("personalAccessory");
        this.updateAnswer(); 
      }
    },
    dataMobility: {
      get () { return this.mobility },
      set (value) {
        if(value.nombre === undefined){
          this.mobility = null
        } else{
          this.mobility = value
        }
        this.brand = null
        this.mobilityType = null
        this.mobilityColor = null
        this.mobilityColorMultiSelect = []
        this.dataMobilityTypeList = value.nombre
        this.dataBrandList = value.nombre
        this.dataMobilityColorList = value.nombre
        this.createPhrase("mobility")
        this.updateAnswer() 
      }
    },
    dataMobilityTypeList:  {
      get ()  { this.mobilityTypeList },
      set (value)  {
        switch (value) {
          case "A pie":
            this.mobilityTypeList = []
            break;
          case "Bicicleta":
            this.mobilityTypeList = this.typeBikeList
            break;
          case "Motocicleta":
            this.mobilityTypeList = this.typeMotorcycleList
            break;
          case "Automovil":
            this.mobilityTypeList = this.typeCarList
            break;
          default:
            this.mobilityTypeList = []
        }
      }
    },
    dataBrandList:  {
      get ()  { this.brand },
      set (value)  {
        switch (value) {
          case "A pie":
            this.brandList  = []
            break;
          case "Bicicleta":
            this.brandList  = this.brandBikeList
            break;
          case "Motocicleta":
            this.brandList  = this.brandMotorcycleList
            break;
          case "Automovil":
            this.brandList  = this.brandCarList
            break;
          default:
            this.brandList  = []
        }
        this.updateAnswer() 
      }
    },
    dataMobilityColorList:  {
      get ()  { this.mobilityColorList },
      set (value)  {
        if(value === "A pie" || value === undefined ){
          this.mobilityColorList = []
        } else  {
          this.mobilityColorList = this.mobilityColorListEnabled
        }
        this.updateAnswer() 
      }
    },
    dataWeaponElementList:  {
      get ()  { this.weaponElement },
      set (value)  {
        switch (value) {
          case "Arma blanca":
            this.weaponElementList  =  this.whiteWeaponList
            break;
          case "Arma de fuego":
            this.weaponElementList  = this.fireWeaponList
            break;
          case "Objeto":
            this.weaponElementList  = this.objectWeaponList
            break;
          default:
            this.brandList  = []
        }
        this.updateAnswer() 
      }
    },
    dataWeaponCaliber: {
      get () { return this.weaponCaliber },
      set (value) {
        if(value === undefined){
          this.weaponCaliber = null
        } else{
          this.weaponCaliber = value
        }
        this.createPhrase("weapon") 
        this.updateAnswer() 
      }
    },
    dataTypeOfWeapon: {
      get () { return this.typeOfWeapon },
      set (value) {
        if(value.nombre === undefined){
          this.typeOfWeapon = {"id": '', "nombre": '' }
        } else{
          this.typeOfWeapon = value
        }
        this.weaponElement = null
        this.weaponColor = null
        this.weaponColorMultiSelect = []
        this.mobilityColorMultiSelect = []
        this.weaponCaliber = null
        this.dataWeaponElementList = value.nombre
        this.textAreaContent = ""
        this.updateAnswer() 
      }
    },
  },
};

export function generateAdvancedComputed(items) {
  return Object.fromEntries(
    items.map(item => [
      `data${capitalize(item.key)}`,
      resolveComputed(item)
    ])
  )
}

function resolveComputed(item) {
  switch (item.type) {
    case 'multiSelect': return multiSelectComputed(item)
    case 'object': return objectComputed(item)
    default:
      console.warn(`Tipo de computed desconocido: ${item.type}`)
      return { get() { return this[item.key] }, set() {} }
  }
}

function multiSelectComputed({ key, multiKey, phraseKey }) {
  return {
    get() { return this[key] },
    set(value) {
      const multiSelectData = { nameMultiSelect: multiKey, nameString: key };
      this.selectOptionsMultiSelect(value, multiSelectData);
      this.createPhrase(phraseKey)
      this.updateAnswer()
    }
  }
}

function objectComputed({ key, phraseKey }) {
  return {
    get() { return this[key] },
    set(value) {
      this[key] = value?.nombre === undefined ? null : value
      this.createPhrase(phraseKey)
      this.updateAnswer()
    }
  }
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}